import { formatInTz, nowInTimezone, startOfMonthInTz, endOfMonthInTz, subMonths } from './timezone';

export interface MonthOption {
  value: string;      // e.g., '2026-01'
  label: string;      // e.g., 'January 2026'
  startDate: Date;
  endDate: Date;
}

/**
 * Generate a list of month options for selection.
 * Returns current month + last 12 months (13 total).
 */
export const generateMonthOptions = (timezone: string): MonthOption[] => {
  const months: MonthOption[] = [];
  const now = nowInTimezone(timezone);
  
  for (let i = 0; i <= 12; i++) {
    const referenceDate = subMonths(now, i);
    const monthStart = startOfMonthInTz(referenceDate, timezone);
    const monthEnd = endOfMonthInTz(referenceDate, timezone);
    
    // Format value as YYYY-MM
    const year = formatInTz(monthStart, timezone, 'yyyy');
    const month = formatInTz(monthStart, timezone, 'MM');
    const value = `${year}-${month}`;
    
    // Format label as "Month Year"
    const label = formatInTz(monthStart, timezone, 'MMMM yyyy');
    
    months.push({
      value,
      label,
      startDate: monthStart,
      endDate: monthEnd,
    });
  }
  
  return months;
};

/**
 * Parse a month value (YYYY-MM) and return start/end dates in the given timezone.
 */
export const parseMonthValue = (value: string, timezone: string): { startDate: Date; endDate: Date } => {
  const [year, month] = value.split('-').map(Number);
  const referenceDate = new Date(year, month - 1, 15); // Mid-month to avoid edge cases
  return {
    startDate: startOfMonthInTz(referenceDate, timezone),
    endDate: endOfMonthInTz(referenceDate, timezone),
  };
};
